package ru.villawonka.app.presentation.screens.setup.model

import ru.villawonka.app.presentation.model.CountryUIModel

data class CountryButtonUIModel(
    val badge: String?,
    val enabled: Boolean,
    val country: CountryUIModel
)

fun CountryUIModel.toCountryButtonUiModel(): CountryButtonUIModel = CountryButtonUIModel(
    badge = null,
    enabled = true,
    country = this
)